import { toast } from 'react-toastify';
import { tbhApiNew } from '../../config/axiosInstanceTBH';
import { baseUrl_, swqtk, timeout } from '../constants';
import { decryptJson } from '../decryptJson';
import { encryptData } from '../encryptJson';
import { handleError } from '../errorHandler';
import customToast, { ToastType } from '../../components_/Toast';
import axios from 'axios';
import { Request } from '../../apis/request';

type TArgs = {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  type: string;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
};
function selectPayment({ setLoading, type, setShow }: TArgs): void {
  setLoading(true);
  const token = localStorage.getItem('paymentToken');
  const id = decryptJson(localStorage.getItem('businessId'));

  const packageId = decryptJson(localStorage.getItem('package-id'));
  // tbhApiNew.defaults.headers.common['Authorization'] = `Bearer ${token}`;

  const getEncryptedString = (amount: number) => {
    Request.post(
      `${baseUrl_}/entrepreneur/new-business/` + id + '/payment/encrypted-string',
      encryptData({
        amount: amount.toString(),
        paymentGatewayType: type,
      }),
      {
        headers: {
          Authorization: `Bearer ${token ?? ''}`,
          sessId: localStorage.getItem('sessId') ?? '',
        },
        timeout,
      },
    )
      .then(({ data }: any) => {
        setLoading(false);
        const decrypted = decryptJson(data.data);
        if (type === 'interswitch') {
          setTimeout(() => {
            window.open(swqtk + '?q=' + decrypted.paymentString, '_top');
          });
        } else {
          setTimeout(() => {
            window.open(decrypted.paymentLink, '_top');
          });
        }
        setShow(false);
      })
      .catch((err: any) => {
        const errorFunction = () => {
          setLoading(false);
          setShow(false);
          customToast(`${err.response.data.message}, please try again`, ToastType.error);
        };
        handleError({ error: err, errorFn: errorFunction });
      });
  };
  const makePayment = async () => {
    try {
      const res = await Request.get(`/servicechargelogs/active/${packageId}`, {
        headers: {
          Authorization: `Bearer ${token ?? ''}`,
          sessId: localStorage.getItem('sessId') ?? '',
        },
        timeout,
      });
      if (res) {
        const data = decryptJson(res.data.data);
        getEncryptedString(data?.price ?? 0);
      }
    } catch (err: any) {
      const errorFunction = () => {
        setLoading(false);
        setShow(false);
        customToast(`${err.response.data.message}, please try again`, ToastType.error);
      };
      handleError({ error: err, errorFn: errorFunction });
    }
  };

  makePayment();
}

export default selectPayment;
